const Card5 = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      className="scale-110 z-20"
    >
      <circle cx="28" cy="28" r="28" fill="#FFFFFF" />
      <path
        d="M36.3624 27.5764H36.4411V20.0198C36.4411 17.8037 34.7198 16 32.5937 16H19.8361C17.7213 16 16 17.8037 16 20.0198V37.5849C16 39.8128 17.7213 41.6164 19.8361 41.6164H28.6112C27.835 40.2255 27.385 38.5985 27.3962 36.8656C27.4299 31.7142 31.4462 27.541 36.3624 27.5764ZM21.6137 21.6585H30.8161C31.4462 21.6585 31.9411 22.189 31.9411 22.8374C31.9411 23.4976 31.4462 24.0163 30.8161 24.0163H21.6137C20.9949 24.0163 20.4887 23.4976 20.4887 22.8374C20.4887 22.189 20.9949 21.6585 21.6137 21.6585ZM23.8299 35.9461H21.6137C20.9949 35.9461 20.4887 35.4157 20.4887 34.7672C20.4887 34.1073 20.9949 33.5884 21.6137 33.5884H23.8299C24.46 33.5884 24.9549 34.1073 24.9549 34.7672C24.9549 35.4157 24.46 35.9461 23.8299 35.9461ZM26.8337 29.9813H21.6137C20.9949 29.9813 20.4887 29.4506 20.4887 28.8025C20.4887 28.154 20.9949 27.6236 21.6137 27.6236H26.8337C27.4636 27.6236 27.9587 28.154 27.9587 28.8025C27.9587 29.4506 27.4636 29.9813 26.8337 29.9813Z"
        fill="#009E3E"
      />
      <path
        d="M43.7952 36.96C43.8065 33.1405 40.8814 30.0046 37.2364 29.9341H37.1465C33.479 29.9105 30.4639 33.0343 30.4415 36.8774C30.4179 40.7139 33.3923 43.8809 37.0678 43.9033C40.7578 43.9269 43.7727 40.8149 43.7952 36.96ZM39.5878 36.5945L37.349 38.9168C36.9317 39.3541 36.2302 39.393 35.7515 38.9168L34.6378 37.7379C34.2103 37.2783 34.2103 36.5237 34.649 36.0641C35.099 35.616 35.8077 35.616 36.2466 36.0759L36.5616 36.4178C36.6742 36.3016 38.1254 34.8044 38.0127 34.9206C38.4515 34.4607 39.1603 34.4607 39.599 34.9324C40.0377 35.392 40.0264 36.1349 39.5878 36.5945Z"
        fill="#009E3E"
      />
    </svg>
  );
};

export default Card5;
